import { Component, OnInit } from '@angular/core';
import { columnDefs, Contractor } from './msa-expiry.helper';
import { MsaExpiringEnum } from '@constants/global.enum';
import { ExpiringContractsService } from './msa-expiry.service';
import { paginationParams } from '@shared/config/table.config';
@Component({
  selector: 'app-msa-expiry',
  templateUrl: './msa-expiry.component.html',
  styleUrls: ['./msa-expiry.component.scss']
})
export class MsaExpiryComponent implements OnInit {
  contractors: Contractor[] = [];
  filteredContractors: Contractor[] = [];
  filterValue: string = '';
  imageSrc: string = 'assets/img/no-data-found.png';
  readonly PAGINATION_MIN_RECORDS = 5;
  maxTableHeight: number = 300;
  paginationParams = { ...paginationParams, pageSize: 5 };
  componentTitle: string = MsaExpiringEnum.Title;
  noDataMessage = MsaExpiringEnum.msaExpiry;
  altText = MsaExpiringEnum.alt;

  columnDefs = columnDefs;

  constructor(private expiringContractsService: ExpiringContractsService) {}

  ngOnInit(): void {
    this.fetchExpiringMSA();
  }

  fetchExpiringMSA(): void {
    this.expiringContractsService.getVendorExpiringMSA().subscribe({
      next: (response) => {
        this.contractors = (response?.data || []).map((item: any) => ({
          vendorName: item.vendorName,
          pointOfContact: item.pointOfContact,
          msaExpiryDate: item.msaExpiryDate,
          numberOfDaysLeft: item.numberOfDaysLeft,
        }));
        this.filteredContractors = [...this.contractors];
        this.updatePagination();
      },
      error: () => {
        this.contractors = [];
        this.filteredContractors = [];
        this.updatePagination();
      }
    });
  }

  searchContracts(event: KeyboardEvent): void {
    const searchTerm = (event.target as HTMLInputElement).value.toLowerCase();
    this.filterValue = searchTerm;
    this.filteredContractors = this.contractors.filter((contractor) =>
      contractor.vendorName?.toLowerCase().includes(searchTerm) ||
      contractor.pointOfContact?.toLowerCase().includes(searchTerm) ||
      contractor.msaExpiryDate?.toLowerCase().includes(searchTerm)
    );
    this.filteredContractors = [...this.filteredContractors];
    this.updatePagination();
  }

  clearInput(): void {
    this.filterValue = '';
    this.filteredContractors = [...this.contractors];
    this.updatePagination();
  }

  updatePagination(): void {
    this.paginationParams.enabled =
      this.filteredContractors?.length > this.PAGINATION_MIN_RECORDS;
  }
}